import {pickMonth} from '.';

export function toMonthDay(date: Date) {
  return `${pickMonth(date)} ${date.getDate()}`;
}
